export default __webpack_public_path__ + "static/diplomats_Advocate_INFJ_career_path-fcdf928a4640c416c3c1533e6f634bdf.svg";